export enum DispatchStatus {
  Success = 'success',
  Pending = 'pending',
  Infeasible = 'infeasible',
  Failed = 'failed',
  UnexpectedError = 'error',
}
